"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    if (!theme) {
        theme = styling_1.getTheme();
    }
    var DefaultStyles = {
        root: {
            margin: "16px 8px",
            boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.4)"
        },
        header: {
            padding: "4px 8px",
            selectors: {
                ".ms-RatingStar-front": {
                    color: theme.palette.yellow
                }
            }
        },
        author: {
            fontWeight: styling_1.FontWeights.semibold
        },
        date: {
            color: theme.palette.neutralSecondary
        },
        rating: {},
        body: {
            padding: "4px 8px"
        },
        content: {
            marginTop: 8,
            marginBottom: 8
        }
    };
    return styling_1.concatStyleSets(DefaultStyles, customStyles);
});
exports.getStyles = getStyles;
